const sumContactCounts = (entries) => entries.reduce((total, entry) => {
    const count = Number(entry?.count);
    return total + (Number.isFinite(count) ? Math.max(0, count) : 0);
}, 0);

/**
 * Return the total recorded contact attempts for a reporting lead row.
 *
 * Some lead-list responses currently serialize an unannotated `contacted_count`
 * as zero while still carrying the authoritative LeadContactedCount rows. A
 * positive scalar wins; otherwise nested rows recover the real total. The
 * top-level row collection and nested treatment collections are alternatives,
 * never added together, so the same contact is not double-counted.
 */
export const getReportLeadContactCount = (item = {}) => {
    const topLevelCounts = Array.isArray(item.lead_contacted_counts)
        ? item.lead_contacted_counts
        : [];
    const treatmentCounts = (Array.isArray(item.lead_treatments) ? item.lead_treatments : [])
        .flatMap((treatment) => (
            Array.isArray(treatment?.lead_contacted_counts)
                ? treatment.lead_contacted_counts
                : []
        ));
    const fallbackCount = sumContactCounts(
        topLevelCounts.length > 0 ? topLevelCounts : treatmentCounts
    );
    const scalar = [item.contacted_count, item.contactedCount, item.timesContacted]
        .find((value) => value !== null && value !== undefined && Number.isFinite(Number(value)));
    const scalarCount = scalar === undefined ? null : Math.max(0, Number(scalar));

    if (scalarCount !== null && (scalarCount > 0 || fallbackCount === 0)) return scalarCount;
    return fallbackCount;
};
